<template>
    <CompanyBoxContent>
        <!-- Basic info -->
        <template #title>
            <div class="row">
            </div>
        </template>

        <template #data>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="title">
                        <h3>{{ $t('company.basicInfo') }}</h3>
                    </div>
                    <div v-if="company.name" class="row">
                        <span class="col-4">{{ $t('company.name') }}:</span>
                        <span class="fw-bold col-8">
                            <span v-if="downloadedName">{{ downloadedName }}</span>
                            <span v-else>{{ company.name }}</span>
                        </span>
                        <div class="offset-4 col-8 mb-2"
                            v-if="company.legal_form && ['105', '100', '425', '101', '107', '424'].includes(company.legal_form.code) && !downloadedName">
                            <button class="btn btn_main d-flex align-items-center" data-bs-toggle="modal"
                                data-bs-target="#nameGDPR">
                                <span>{{ $t("company.downloadName") }}</span>
                            </button>
                        </div>
                    </div>
                    <span v-if="company.organization_id" class="row">
                        <span class="col-4">{{ $t("company.organizationId") }}:</span>
                        <span class="col-8">{{ company.organization_id }}</span>
                    </span>
                    <span v-if="company.tax_id" class="row">
                        <span class="col-4">{{ $t("company.taxId") }}:</span>
                        <span class="col-8">{{ company.tax_id }}</span>
                    </span>
                    <span v-if="company.address" class="row">
                        <span class="col-4">{{ $t("company.address") }}:</span>
                        <router-link :to="{ name: 'companiesSameAddress', params: { slug: company.address.uuid } }"
                            class="router_link col-8">
                            <span>{{ company.address.whole_address }}</span>
                        </router-link>
                    </span>
                    <span v-if="company.creation_date" class="row">
                        <span class="col-4">{{ $t("company.creationDate") }}: </span>
                        <i18n-d class="col-8" tag="span" :value="new Date(company.creation_date)"></i18n-d>
                    </span>
                    <span v-if="company.expiry_date" class="row">
                        <span class="col-4">{{ $t("company.expiryDate") }}: </span>
                        <i18n-d class="col-8" tag="span" :value="new Date(company.expiry_date)"></i18n-d>
                    </span>
                    <span v-if="company.legal_form" class="row">
                        <span class="col-4">{{ $t("company.legalForm") }}:</span>
                        <span class="col-8">{{ company.legal_form.name }}</span>
                    </span>
                    <span v-if="company.employees" class="row">
                        <span class="col-4">{{ $t("company.employees") }}:</span>
                        <span class="col-8">{{ company.employees.name }}</span>
                    </span>
                    <span v-if="company.website" class="row">
                        <span class="col-4">{{ $t("company.website") }}:</span>
                        <span class="col-8">
                            <a :href="company.website" target="_blank" rel="noopener noreferrer"
                                class="router_link" style="text-decoration: underline;">
                                {{ company.website }}
                            </a>
                        </span>
                    </span>
                </div>
                <div v-if="companyAddress && companyAddress.length > 0" class="col-12 col-lg-6 mt-4 mt-lg-0">
                    <div class="title">
                        <h3>{{ $t('company.map') }}</h3>
                    </div>
                    <div v-if="existCompanyResidenceMap()" class="d-flex align-items-center justify-content-center">
                        <div class="" id="map">
                            <Map :companyAddress="companyAddress" />
                        </div>
                    </div>
                    <div v-else class="d-flex custom_box align-items-stretch h-75 justify-content-center">
                        <div class="text-center align-self-center w-100">
                            <span style="font-size: 18px; font-weight: 500;">{{ $t('company.mapNotAvailible') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>

    <Popup :header="$t('company.showNameGDPR')" :editable="false" id="nameGDPR" :showButton="true"
        @save-data="downloadName" :button="$t('company.downloadName')">
        <template v-slot:body>
            <div class="box">
                <p v-html="$t('company.GDPRNameText')"></p>
            </div>
        </template>
    </Popup>
</template>

<script>
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"
import Map from '@/components/CompanyDetail/Map.vue';
import Popup from "@/components/Popup.vue";
import axios from "axios"

export default {
    props: {
        company: {
            type: Object,
            required: true
        },
        companyAddress: {
            type: Array,
            required: true
        },
    },
    components: {
        CompanyBoxContent,
        Map,
        Popup
    },
    data: function () {
        return {
            downloadedName: null
        }
    },
    methods: {
        existCompanyResidenceMap() {
            if (this.companyAddress) {
                return this.companyAddress.some(item => item.residence === true && item.address.lat && item.address.lon);

            }
            return false;
        },
        downloadName: function () {
            axios.get("https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty-res/" + this.company.organization_id).then(
                function (response) {
                    this.downloadedName = response.data.zaznamy[0].obchodniJmeno
                }.bind(this)
            ).catch(
                axios.get("https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty-rzp/" + this.company.organization_id).then(
                    function (response) {
                        this.downloadedName = response.data.zaznamy[0].obchodniJmeno
                    }.bind(this)
                )
            )
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.title {
    padding: 0 0 5px 20px;

    h3 {
        font-weight: 700;
        font-size: clamp(18px, 1.8vw, 24px);
    }
}

.btn_show_name {
    background-color: $dark-purple;
    color: $white;
    font-size: 1rem;
    font-weight: 700;
    padding: 5px 25px;
}

#map {
    height: 220px;
    width: 100%;
    border-radius: $radius-lg;
}

.custom_box {
    border-radius: $radius-lg;
    background-color: $white;
    color: black;
}

.router_link {
    color: $accent;
}
</style>